// extracted by mini-css-extract-plugin
module.exports = {"newestArticles":"NewestArticles_newestArticles__1bWC-","container":"NewestArticles_container__2E0oW"};